import api from './api';
import { Department } from '../types/user';

/**
 * Fetch all departments from the API
 * @returns Promise with departments data
 */
export async function getDepartments(): Promise<Department[]> {
    try {
        const response = await api.get<Department[]>('/departments');
        return response.data;
    } catch (error) {
        console.error('Error fetching departments:', error);
        throw error;
    }
}

/**
 * Fetch a specific department by ID
 * @param id Department ID
 * @returns Promise with department data
 */
export async function getDepartment(id: number): Promise<Department> {
    try {
        const response = await api.get<Department>(`/departments/${id}`);
        return response.data;
    } catch (error) {
        console.error('Error fetching department:', error);
        throw error;
    }
}
